<template>
  <div class="content">
    <p><strong>医用分子筛制氧系统合法合规性阐述：</strong></p>
    <p><strong>1，分子筛制氧符合下列国家法律及国家新标准：</strong></p>
    <p>（1）1990年美国将分子筛制氧纳入《美国药典》。</p>
    <p>
      （2）中国国家药品食品监督管理局在1997年参考美国FDA相关技术规范和标准也正式制定并颁布了中国<em
        >《医用分子筛制氧设备通用技术规范》YY/T0298-1998标准。</em
      ><strong
        >根据现有相关法律法规，医用分子筛制氧设备作为<em>二类医疗器械管理（Ⅱ类编号6854医用制氧设备）</em>，其在医疗机构的使用应遵守《医疗器械使用质量监督管理办法》要求，</strong
      >无需向食品药品监督管理部门备案。
    </p>
    <p>
      （3）氧气浓度要求：国家药品食品监督管理局颁布的《医用分子筛制氧设备通用技术规范》YY/T
      0298-1998标准规定医用分子筛制氧氧气浓度必须≥93%±3%v/v以上，也就是医用分子筛制氧氧气浓度不得低于90%，其中杂质为普通空气中的氮气，完全无害。<strong
        ><em
          >医用分子筛制氧设备制备的富氧空气按药品监管，其质量应符合国家药典委员会制定的富氧空气标准（93±3%氧，标准编号：WS1-XG-008-2012）要求即可。</em
        ></strong
      >
    </p>
    <p>
      （4）为了更好地规范和推广使用富氧空气氧），国家食品药品监督管理总局推出<strong
        ><em
          >YY
          1468-2016《用于医用气体管道系统的氧气浓缩器供气系统》，该标准于2016年1月26日发布，2018年1月1日实施。</em
        >新标准的推行，将“YY/T”变为“YY”，升级成为<em>强制性标准！明确表示浓缩器可以进行管道供应，</em>并</strong
      >指出：A:氧气浓缩器（如：分子筛制氧系统）制取的氧气（富氧空气，93%氧）可以用于医用气体管道系统；<strong>B:氧气浓缩器能用于向医用气体管道系统输送作为医用氧气（如：中国药典中的“氧”）替代品的富氧空气（93%氧）</strong>；C:氧气浓缩器可与含有100%医用氧气的供气源（即氧气瓶或低温容器）组合使用；D:用氧方式的使用选择权在于医疗卫生机构自身；E:带有氧气浓缩器的供气系统能在管道分配系统安装时进行安装或作为已有供气系统的替代或附加。<strong
        >F:标准中已明确了氧气浓缩器制取的氧气可以用于在医疗机构中的医用气体管道系统，并没有适用范围的限定。</strong
      >
    </p>
  </div>
</template>

<script>
export default {
  name: 'TabOxygenConcentratorCompliance'
}
</script>

<style lang="scss" scoped>
.content {
  font-size: 18px;
  color: #6a6a6a;
  p {
    line-height: 36px;
    text-indent: 40px;
  }
  em {
    color: red;
  }
  strong{
    font-size: 20px;
    font-weight: 700;
  }
}
</style>
